export class ViewApplicationDetailsPlamsConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static APPLICATION_TYPE_LABEL = "Application type";
    static LEASE_LABEL = "Lease details";
    static DRAW_POLYGON_LABEL = "Please draw an area (polygon) around the lease area on the location tab.";
    static POLYGON_DRAWN_LABEL = "Lease area selected.";
    static LEASE_TYPE_LABEL = "Lease type";
    static LEASE_REASON_LABEL = "Lease reason";
    static LEASE_USE_LABEL = "What will the lease be used for?";
    static LEASE_RENTAL_AGREEMENT_LABEL = "Lease rental agreement amount (p/m)";
    static LEASE_START_DATE_LABEL = "Lease start date";
    static LEASE_END_DATE_FORM_LABEL = "Lease end date";
    static LEASE_CONTRACT_NUMBER_LabeL = "Lease contract number";
    static LEASE_ACCOUNT_NUMBER_LabeL = "Lease account number";
    static LEASE_COMMENTS_LabeL = "Lease comments";
    static LEASE_CONTRACT_ESCALLATION_LabeL = "Lease contract escalation";
    static LEASE_PERIOD_LabeL = "Lease period";
    static LEASE_NOTICE_PERIOD_DATE_LabeL = "Lease notice period";
    static LEASE_STATUS_ACCORDING_TO_COUNCIL_LabeL = "Lease status according to council";
    static LESSEE_LABEL = "Lessee";
    static SELLER_LABEL = "Seller";
    static BUYER_LABEL = "Buyer";
    static LESSEE_TYPE_LABEL = "Lessee type";
    static ALIENATION_LABEL = "Alienation details";
    static SALE_AMOUNT_LABEL = "Sale amount (R)";
    static DATE_OF_DEED_TRANSFER_LABEL = "Date of deed transfer";
    static EVALUATION_AMOUNT_LABEL = "Evaluation amount";
    static ACQUISITION_LABEL = "Acquisition details";
    static COPY_APPLICANT_TO_LESSEE_LABEL = "Copy applicant to lessee";
    static COPY_APPLICANT_TO_BUYER_LABEL = "Copy applicant to buyer";
    static COPY_APPLICANT_TO_SELLER_LABEL = "Copy applicant to seller";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static TRANSFERRING_ATTORNEY_LABEL = "Transferring attorney";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "applicationType";
    static LEASE_TYPE_FORM_CONTROL_NAME = "leaseType";
    static LEASE_REASON_FORM_CONTROL_NAME = "leaseReason";
    static LEASE_USE_FORM_CONTROL_NAME = "leaseUse";
    static LEASE_RENTAL_AGREEMENT_FORM_CONTROL_NAME = "leaseRentalAgreementAmount";
    static LEASE_START_DATE_FORM_CONTROL_NAME = "leaseStartDate";
    static LEASE_END_DATE_FORM_CONTROL_NAME = "leaseEndDate";
    static LEASE_CONTRACT_NUMBER_FORM_CONTROL_NAME = "leaseContractNumber";
    static LEASE_ACCOUNT_NUMBER_FORM_CONTROL_NAME = "leaseAccountNumber";
    static LEASE_COMMENTS_FORM_CONTROL_NAME = "leaseComments";
    static LEASE_CONTRACT_ESCALATION_FORM_CONTROL_NAME = "leaseContractEscalation";
    static LEASE_PERIOD_FORM_CONTROL_NAME = "leasePeriod";
    static LEASE_NOTICE_PERIOD_DATE_FORM_CONTROL_NAME = "leaseNoticePeriod";
    static LEASE_STATUS_ACCORDING_TO_COUNCIL_FORM_CONTROL_NAME = "leaseStatusAccordingToCouncilResolution";
    static LESSEE_TYPE_FORM_CONTROL_NAME = "lesseeType";
    static LESSEE_FORM_CONTROL_NAME = "lesseeRecipient";
    static SALE_AMOUNT_FORM_CONTROL_NAME = "saleAmount";
    static DATE_OF_DEED_TRANSFER_FORM_CONTROL_NAME = "dateOfDeedTransfer";
    static EVALUATION_AMOUNT_FORM_CONTROL_NAME = "evaluationAmount";
    static BUYER_FORM_CONTROL_NAME = "buyerRecipient";
    static SELLER_FORM_CONTROL_NAME = "sellerRecipient";
    static SALE_AMOUNT_ALIENATION_FORM_CONTROL_NAME = "saleAmountAlienation";
    static DATE_OF_DEED_TRANSFER_ALIENATION_FORM_CONTROL_NAME = "dateOfDeedTransferAlienation";
    static EVALUATION_AMOUNT_ALIENATION_FORM_CONTROL_NAME = "evaluationAmountAlienation";
    static REFERENCE_NUMBER_FORM_CONTROL_NAME = "referenceNumber";
    static TRANSFERRING_ATTORNEY_FORM_CONTROL_NAME = "transferringAttorneyRecipient";
}
